import React, { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { Spin } from 'antd';

const CrmDashboardView = lazy(() => import('./views/CrmDashboardView'));
const InteractionListView = lazy(() => import('./views/InteractionListView'));
const TaskListView = lazy(() => import('./views/TaskListView'));
const LeadListView = lazy(() => import('./views/LeadListView'));

const Loader = () => (
    <div className="flex justify-center p-8"><Spin size="large" /></div>
);

export const crmRoutes: RouteObject[] = [
    {
        path: '/crm',
        element: <Suspense fallback={<Loader />}><CrmDashboardView /></Suspense>,
    },
    {
        path: '/crm/interactions',
        element: <Suspense fallback={<Loader />}><InteractionListView /></Suspense>,
    },
    {
        path: '/crm/tasks',
        element: <Suspense fallback={<Loader />}><TaskListView /></Suspense>,
    },
    {
        path: '/crm/leads',
        element: <Suspense fallback={<Loader />}><LeadListView /></Suspense>,
    },
];
